import { Injectable } from '@angular/core';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import {exportPDF} from "@progress/kendo-drawing";
import {AppNotificationService} from "./app-notification.service";

@Injectable({
  providedIn: 'root'
})
export class PdfExportService {

  constructor(private notificationService: AppNotificationService) { }

  public async waitForPdfExport(getPdfExport: () => PDFExportComponent | null): Promise<PDFExportComponent> {
    return new Promise<PDFExportComponent>((resolve) => {
      const check = () => {
        const pdfExport = getPdfExport();
        if (pdfExport) {
          resolve(pdfExport);
        } else {
          requestAnimationFrame(check);
        }
      };
      check();
    });
  }

  public async generateAndPrint(pdfExport: PDFExportComponent): Promise<void> {
    try {
      const oldIframe = document.querySelector('iframe.print-pdf-iframe');
      if (oldIframe && oldIframe.parentNode) {
        oldIframe.parentNode.removeChild(oldIframe);
      }

      const group = await pdfExport.export();
      const dataUri = await exportPDF(group);
      const blob = this.base64ToBlob(dataUri);
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = blobUrl;
      iframe.classList.add('print-pdf-iframe');
      document.body.appendChild(iframe);

      iframe.onload = () => {
        const win = iframe.contentWindow;
        if (!win) {
          return;
        }

        win.focus();
        win.print();
      };
    } catch (error) {
      throw error;
    }
  }

  public async print(component: { isPrinting: boolean; loadPdf: boolean },
                     getPdfExport: () => PDFExportComponent | null): Promise<void> {
    component.isPrinting = true;
    document.body.style.cursor = 'wait';

    await new Promise<void>(resolve => requestAnimationFrame(() => resolve()));

    component.loadPdf = true;
    await new Promise(resolve => setTimeout(resolve, 50));

    try {
      const pdf = await this.waitForPdfExport(getPdfExport);
      await this.generateAndPrint(pdf);
    } catch (error) {
      this.notificationService.showNotification('error', 'notification.pdf.klaida');
    } finally {
      component.isPrinting = false;
      component.loadPdf = false;
      document.body.style.cursor = 'default';
    }
  }

  private base64ToBlob(base64: string, type = 'application/pdf'): Blob {
    const binary = atob(base64.split(',')[1]);
    const array = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      array[i] = binary.charCodeAt(i);
    }
    return new Blob([array], { type });
  }

}
